import { Component, Input, OnInit } from '@angular/core'
import { IDataCardSora } from '../../../../../models/data-card.model'
import { DataCardService } from '../../../../../services/data-card.service'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { HttpErrorResponse } from '@angular/common/http'
import { SoraEditorService } from '../../../../../services/admin/configuration/sora-editor.service'
import { HelperService } from '../../../../../services/helper.service'

@Component({
  selector: 'app-sora-item-modal',
  templateUrl: './sora-item-modal.component.html',
  styleUrl: './sora-item-modal.component.scss',
  standalone: false,
})
export class SoraItemModalComponent implements OnInit {
  @Input({ required: true }) mainObject: string

  private _soraData: IDataCardSora
  private _isLoading: boolean = false
  private _isDownloading: { pdf: boolean; doc: boolean } = { pdf: false, doc: false }

  public get soraData(): IDataCardSora {
    return this._soraData
  }

  public get isLoading(): any {
    return this._isLoading
  }

  constructor(
    private service: SoraEditorService,
    private dataCardService: DataCardService,
    private responseHandlerService: HttpResponseHandlerService,
  ) {}

  public onDownloadPDF(): void {
    if (this._isDownloading.pdf) {
      this.responseHandlerService.notifyWarning(
        'Downloading PDF',
        'A download is already in progress.',
      )
      return
    }

    this._isDownloading.pdf = true

    this.service.downloadSoraFormFile('pdf', this.mainObject).subscribe({
      next: (response: any): void => {
        if (response.status && response.status === 'Progress') {
          this._isDownloading.pdf = true
        }
        if (response.status && response.status === 'Completed') {
          setTimeout((): void => {
            this._isDownloading.pdf = false
          }, 1000)

          HelperService.downloadBase64File(
            response.base64,
            'application/pdf',
            `${this.soraData.title}.pdf`
          )
        }
      },
      error: (error: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(error)
        this._isDownloading.pdf = false
      },
    })
  }

  public onDownloadDOC(): void {
    if (this._isDownloading.doc) {
      this.responseHandlerService.notifyWarning(
        'Downloading DOC',
        'A download is already in progress.',
      )
      return
    }

    this._isDownloading.doc = true

    this.service.downloadSoraFormFile('doc', this.mainObject).subscribe({
      next: (response: any): void => {
        if (response.status && response.status === 'Progress') {
          this._isDownloading.doc = true
        }
        if (response.status && response.status === 'Completed') {
          setTimeout((): void => {
            this._isDownloading.doc = false
          }, 1000)

          HelperService.downloadBase64File(
            response.base64,
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            `${this.soraData.title}.docx`
          )
        }
      },
      error: (error: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(error)
        this._isDownloading.doc = false
      },
    })
  }

  private getSoraData(): void {
    this._isLoading = true
    this.dataCardService.getSORAData(this.mainObject).subscribe({
      next: (resource: IDataCardSora): void => {
        this._soraData = resource
        this._isLoading = false
      },
      error: (error: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    })
  }

  ngOnInit(): void {
    this.getSoraData()
  }
}
